module.exports = __webpack_public_path__ + "3605d18d8a4ce5bd39c3d32119574854.woff2";